import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  SetState,
  GetState,
} from '../../components/DailyAgenda/state/createState';
import { initServices } from './initServices/initServices';
import { initSlots } from './initSlots/initSlots';
import { initAvailableDays } from './initAvailableDays/initAvailableDays';
import { initBookings } from './initBookings/initBookings';
import { AsyncComponentDataStatus } from '../../components/DailyAgenda/state/types';
import { DailyAgendaBiLogger } from '../../utils/bi/biLogger';
import { initIsPremium } from './initIsPremium/initIsPremium';
import { TriggeredByOptions } from '../../utils/bi/consts';

export type InitiatorsArgs = {
  flowAPI: ControllerFlowAPI;
  setState: SetState;
  getState: GetState;
  biLogger?: DailyAgendaBiLogger;
};

export const initWidgetData = async (args: InitiatorsArgs) => {
  await initServices(args);
  initIsPremium(args);
  if (!args.flowAPI.environment.isSSR) {
    initAvailableDays(args, TriggeredByOptions.INITIALIZE_WIDGET).then(() => {
      initSlots(args, TriggeredByOptions.INITIALIZE_WIDGET);
      const { availableDays } = args.getState();
      if (availableDays.status === AsyncComponentDataStatus.IDLE) {
        args.biLogger?.reportDatePickerLoad(
          availableDays.data,
          TriggeredByOptions.INITIALIZE_WIDGET,
        );
        args.biLogger?.reportWidgetLoad();
      }
    });
    initBookings(args);
  }
};
